import { render, staticRenderFns } from "./ManageResources.vue?vue&type=template&id=60a5fd70&scoped=true&lang=true"
import script from "./ManageResources.vue?vue&type=script&lang=js"
export * from "./ManageResources.vue?vue&type=script&lang=js"
import style0 from "./ManageResources.vue?vue&type=style&index=0&id=60a5fd70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5fd70",
  null
  
)

export default component.exports